import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceMembershipRequest } from '../../utils/keys';
export const useSpaceMembershipRequests = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const key = getSpaceMembershipRequest(variables, fields);
    return useQuery(key, () => client.spaceMembership.getRequests(variables, fields), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useSpaceMembershipRequests.js.map